import { render, staticRenderFns } from "./FifthQuestion.vue?vue&type=template&id=5879be31&"
import script from "./FifthQuestion.vue?vue&type=script&lang=js&"
export * from "./FifthQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FifthQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports